import React from 'react';
import Title from '../../../../../@casino/ui/title';
import ModalCreateMailing from '../../components/ModalCreate';
import { useDispatch } from 'react-redux';
import { setGetMailing } from '../../../../store/mailing/thunk/setGetMailing';
import { useRouter } from '../../../../../@casino/useRouter';
import General from '../../components/General';
import { Route } from 'react-router-dom';

const MailingList = () => {
    const dispatch = useDispatch();
    const router = useRouter();
    const [isShowCreateMailing, setIsShowCreateMailing] = React.useState(false);
    const [activeTab, setActiveTab] = React.useState('');
    const {pathname} = router;
    const handleChangeModeCreate = () => {
        setIsShowCreateMailing(value => !value);
    }

    React.useEffect(() => {
        dispatch(setGetMailing({
            page: 1,
            pageSize: 25
        }))
    }, []);

   

    React.useEffect(() => {
        if (pathname.includes('statistics')) {
            setActiveTab('statistics')
        } else {
            setActiveTab('general')
        }
    }, [pathname]);

    return (
        <div style={{
            padding: '0 20px 20px',
        }}>
            <Title
                label="Рассылки"
                labelBtn="Создать рассылку"
                button={handleChangeModeCreate}
            />
            {
                isShowCreateMailing && (
                    <ModalCreateMailing handleChangeModeCreate={handleChangeModeCreate} />
                )
            }
      

            <Route exact path="/mailing/list/general" component={() => <General />} />
            <Route exact path="/mailing/list/" component={() => <General />} />
        </div>
    )
}

export default MailingList;